/* eslint-disable @typescript-eslint/no-use-before-define */
import { sumBy, last, filter, each, find } from '@dt/fe-utils/dist/lodash'
import React, { FC, useState, useEffect, useRef } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { IonPage, IonFooter, IonContent, IonToast, IonLoading, IonModal, IonHeader } from '@ionic/react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import payMobx, { ICard, TPayScene } from '@mobx/pay/pay.mobx'
import surchargeMobx from '@mobx/pay/surcharge.mobx'
import { memberMobx } from 'mobx/mkt'
import { bankCardMobx, payChannelMobx, storeMobx } from '@mobxStore'
import { Navigator } from '@cps'
import { uuid, toDecimal } from '@dt/fe-utils'
import { useHistoryNew, getPlatform, miniAppRouteTo } from '@utils'
import OrderSummary from './OrderSummary'
import Bill from './Bill'
import HeartlandTokenizer from './bankCardOnline/HeartlandTokenizer'
import { money } from './util'
import mktController from 'controllers/mktController'
import env from '@env'
import './index.scss'

interface IRouteParams {
  id?: string;
}

interface IBill {
  id: string;
  method?: string;
  card?: ICard;
  amount: number;
  message?: string;
}

let onBankCardToken, onBankCardCancel
/**
 * 支付页面
 * 目前只有充值在使用
 */

const Pay: FC<RouteComponentProps<IRouteParams>> = ({ match }) => {
  const history = useHistoryNew()
  const [tip, setTip] = useState(0)
  const [tipSelected, setTipSelected] = useState(false)
  const [bills, setBills] = useState<IBill[]>([])
  const [errorMessage, setErrorMessage] = useState('')
  const [showLoading, setShowLoading] = useState(false)
  const [showPolicy, setShowPolicy] = useState(false)
  const [memberCard, setMemberCard] = useState<ICard>()
  const [showTokenizer, setShowTokenizer] = useState(null)
  const contentRef = useRef<HTMLIonContentElement>()
  const openIdRef = useRef<{ openId: string; appId?: string }>(null)

  const orderId = match.params.id
  const query = new URLSearchParams(history.location.search)
  const windowQuery = new URLSearchParams(window.location.search)
  const scene = query.get('scene') as TPayScene || windowQuery.get('scene') as TPayScene || 'dining'
  const pcid = query.get('pcid') || windowQuery.get('pcid')

  console.log('pay scene', scene)
  console.log('pcid', pcid)

  const onTipChange = (tip: number) => {
    setTip(tip)
    setTipSelected(true)
  }
  const detachOpenId = () => {
    const { isWeixinMiniProgram } = getPlatform()
    openIdRef.current = {
      openId: window.Config.openId,
      appId: window.Config.appId
    }
  }
  useEffect(() => {
    if (memberMobx.isLogin) {
      const card = memberMobx.cardInfoForPay
      console.info('MemberBalance', card)
      if (card && card.card && card.balance > 0) {
        setMemberCard({
          type: 'memberCard',
          id: String(card.memberCardId),
          name: card.card?.cardName,
          number: card.cardNo,
          balance: card.balance,
          isPayTip: true,
        })
      }
    }

    payMobx.init({ scene, orderId, pcid }).catch((err) => {
      setErrorMessage(err.message)
      if (err.code === -231) {
        setTimeout(() => {
          history.goBack()
        }, 5000)
      }
    })
  }, [memberMobx.isLogin, memberMobx.cardInfoForPay])

  // 自动选择小费
  useEffect(() => {
    if (scene === 'dining') {
      if (payMobx.tipOptions.length > 0) {
        if (!payMobx.tipOptions[0].customTip) {
          onTipChange(payMobx.tipOptions[0].amount)
        }
      }
    }
  }, [payMobx.tipOptions])

  const setBillsAndScroll = (bills) => {
    setBills(bills)
    contentRef.current && contentRef.current.scrollToBottom(800)
  }

  // 自动生成初始分笔支付
  useEffect(() => {
    if (!payMobx.order) return

    let defaultMethod: string, directInvoke: boolean
    if (bo === 'cn' && !!payMobx.methodChannelMap.wechatPay) {
      defaultMethod = 'wechatPay'
    }

    const total = payMobx.order.subtotal + payMobx.order.tax + tip
    const bills = []
    if (scene === 'dining' && memberCard) {
      if (memberCard.balance >= total) {
        bills.push({ id: uuid(), method: 'memberBalance', card: memberCard, amount: total })
      } else {
        bills.push({ id: uuid(), method: 'memberBalance', card: memberCard, amount: memberCard.balance })
        bills.push({ id: uuid(), method: defaultMethod, amount: total - memberCard.balance })
      }
    } else {
      const methodData = payMobx.firstAvaliableMethod
      bills.push({ id: uuid(), method: methodData.method, amount: total, card: methodData.card })
      if (bo === 'cn') {
        directInvoke = true
      }
    }
    setBillsAndScroll(bills)
    // directInvoke && pay()
  }, [payMobx.order, payMobx.methodChannelMap.wechatPay, memberCard, tip, payMobx.firstAvaliableMethod])

  const onBillMethodAndCardChange = (bill: IBill, method: string, card: ICard) => {
    const { id, amount } = bill
    let message: string
    if (method === 'giftCard' && card) {
      if (!card.isPayTip && tip > 0) {
        message = i18n.t('pay.giftCardCannotPayTip')
      }
    }
    const index = bills.indexOf(bill)
    const newBills = [
      ...bills.slice(0, index),
      { id, method, card, amount, message },
      ...bills.slice(index + 1)
    ]
    console.log('newBills', JSON.stringify(newBills))
    setBillsAndScroll(newBills)
  }

  const onDeleteCard = async (method: string, card: ICard) => {
    if (method === 'bankCardOnline') {
      await payMobx.deleteBankCard(card)
      const newBills = []
      each(bills, x => {
        if (x.card && x.card.id === card.id) {
          newBills.push({
            id: x.id,
            amount: x.amount
          })
        } else {
          newBills.push(x)
        }
      })
      console.log('newBills', JSON.stringify(newBills))
      setBills(newBills)
    }
  }

  const onBillAmountChange = (bill: IBill, amount: number) => {
    const { id, method, card } = bill
    const index = bills.indexOf(bill)
    let newBills = [
      ...bills.slice(0, index),
      { id, method, card, amount },
      ...bills.slice(index + 1)
    ]

    let sum = sumBy(newBills, 'amount')
    const total = payMobx.order.subtotal + payMobx.order.tax + tip

    // 现有bills小于总金额
    if (sum < total) {
      // 目前能调整金额的只有会员余额，多出来的钱放在其他支付方式上
      if (newBills.length > 1) {
        newBills[1].amount += total - sum
      } else {
        // 没有其他支付方式，则自动创建新的bill
        newBills.push({
          id: uuid(),
          amount: total - sum
        })
      }
    }

    // 现有bills大于总金额，则从最后一个bill向上减
    while (sum > total) {
      const diff = sum - total
      const lastBill = last(newBills)
      // bill金额小于差额则删除这笔
      if (lastBill.amount < diff) {
        newBills = newBills.slice(0, newBills.length - 1)
      } else {
        // bill金额大于则减去差额
        lastBill.amount -= diff
      }
      sum = sumBy(newBills, 'amount')
    }

    newBills = filter(newBills, x => x.amount > 0)

    if (memberCard) {
      const memberCardBill = find(newBills, x => x.method === 'memberBalance')
      if (!memberCardBill) {
        newBills.unshift({ id: uuid(), method: 'memberBalance', card: memberCard, amount: 0 })
      }
    }

    console.log('newBills', JSON.stringify(newBills))
    setBillsAndScroll(newBills)
  }
  const getOpenIdData = async () => {
    const obj = JSON.parse(memberMobx.thirdAuthInfo) || {}
    const { isWeixinMiniProgram } = getPlatform()
    let openIdData: { openId: string; appId?: string }
    if (isWeixinMiniProgram) {
      openIdData = {
        openId: window.Config.openId,
        appId: window.Config.appId,
      }
    } else {
      openIdData = {
        openId: obj.gOpenId,
      }
    }
    if (!openIdData.openId) {
      openIdData = await payMobx.fetchGOpenIdAndSave()
    }
    return openIdData
  }

  const billToChannel = async (bill: IBill): Promise<{
    uniqueId: string;
    amount: number;
    channelType: string;
    ext?: any;
    surchargeInfo?: any;
    onSuccess?(): void;
    onFailed?(): void;
  }> => {
    const channelType = payMobx.methodChannelMap[bill.method]
    let openIdData
    if (['wechatPay', 'alipay'].includes(bill.method)) {
      openIdData = (await getOpenIdData()) || {}
    }
    let ext
    let isSurcharge = false
    if (channelType === 'CardConnectBankCard') {
      bankCardMobx.setLastUsed({ tokenType: 'multi', creditCardNo: bill.card.id })
      ext = { creditCardNo: bill.card.id }
      isSurcharge = bill.card?.cardType !== 'N'
    } else if (channelType === 'HeartLandBankCard') {
      if (bill.card) {
        bankCardMobx.setLastUsed({ tokenType: 'multi', creditCardNo: bill.card.id })
        ext = { creditCardNo: bill.card.id }
        isSurcharge = bill.card?.cardType !== 'N'
      } else {
        setShowLoading(false)
        const token = await new Promise((resolve, reject) => {
          setShowTokenizer(true)
          onBankCardToken = (token) => {
            setShowTokenizer(false)
            setShowLoading(true)
            resolve(token)
          }
          onBankCardCancel = () => {
            setShowLoading(true)
            reject(new Error('CANCEL'))
          }
        })
        ext = { authCode: token }
      }
    } else if (channelType === 'GiftCard') {
      ext = { cardId: bill.card.id, cardNumber: bill.card.number, token: memberMobx.token }
    } else if (channelType === 'MemberBalance') {
      ext = { cardId: bill.card.id, cardNumber: bill.card.number, memeberId: memberMobx.memberInfo?.memberId, token: memberMobx.token }
    } else if (channelType === 'CitconAlipayWeb') {
      ext = { returnUrl: getReturnUrl() }
    } else if (channelType === 'CitconWechatPayWeb') {
      ext = { returnUrl: getReturnUrl() }
    } else if (channelType === 'CardConnectApplePay' || channelType === 'GlobalPaymentsApplePay') {
      const total: ApplePayJS.ApplePayLineItem = {
        type: 'final',
        label: 'Dining',
        amount: String(bill.amount)
      }
      return new Promise((resolve, reject) => {
        const session = new ApplePaySession(1, {
          countryCode: 'US',
          currencyCode: 'USD',
          supportedNetworks: ['amex', 'visa', 'masterCard', 'discover'],
          merchantCapabilities: ['supports3DS'],
          total,
        })
        session.onvalidatemerchant = async function (event) {
          console.log('onvalidatemerchant', event)
          try {
            const merchantSession = await payMobx.applePayMerchantValidate(event)
            session.completeMerchantValidation(merchantSession)
          } catch (e) {
            session.abort()
            reject(e)
          }
        }
        session.onpaymentmethodselected = async function (event) {
          console.log('onpaymentmethodselected', event)
          session.completePaymentMethodSelection({ newTotal: total })
        }
        session.onpaymentauthorized = async function (event) {
          console.log('onpaymentauthorized', event)
          const { paymentData } = event.payment.token
          const { data, header, signature, version } = paymentData
          const { ephemeralPublicKey, publicKeyHash, transactionId } = header
          resolve({
            uniqueId: bill.id,
            amount: bill.amount,
            channelType,
            ext: {
              data,
              signature,
              version,
              ephemeralPublicKey,
              publicKeyHash,
              transactionId,
            },
            onSuccess () {
              session.completePayment((window as any).ApplePaySession.STATUS_SUCCESS)
            },
            onFailed () {
              session.abort()
            }
          })
        }
        session.oncancel = function () {
          console.log('oncancel')
          reject('cancel')
        }
        session.begin()
      })
    } else if (channelType === 'StripeApplePay') {
      return new Promise((resolve, reject) => {
        const Stripe = (window as any).Stripe
        Stripe.setPublishableKey(payChannelMobx.channelAccount.StripeApplePay?.publicApiKey)
        const paymentRequest = {
          countryCode: 'US',
          currencyCode: 'USD',
          total: {
            label: storeMobx.info.storeName,
            amount: String(bill.amount),
          }
        }
        const session = Stripe.applePay.buildSession(paymentRequest, (result, completion) => {
          resolve({
            uniqueId: bill.id,
            amount: bill.amount,
            channelType,
            ext: { authCode: result.token.id },
            onSuccess () {
              completion((window as any).ApplePaySession.STATUS_SUCCESS)
            },
            onFailed () {
              completion((window as any).ApplePaySession.STATUS_FAILURE)
            }
          })
        }, reject)
        session.oncancel = function () {
          console.log('oncancel')
          reject('cancel')
        }
        session.begin()
      })
    } else if (['WechatPayWeb', 'ShengPayWechatWeb', 'ShengPayWechatWebV2'].includes(channelType)) {
      ext = openIdData
    } else if (channelType === 'AlipayWeb') {
      ext = { returnUrl: getReturnUrl() }
    } else if (['AlipayApp', 'ShengPayAlipayWeb', 'ShengPayAlipayWebV2'].includes(channelType)) {
      ext = {
        buyerId: openIdData.openId
      }
    } else if (channelType === 'PayPalWeb') {
      ext = { returnUrl: getReturnUrl() }
    }

    // 附加费
    const surchargeConfig = surchargeMobx.surchargeMap?.[channelType]
    const surchargeInfo: any = {}
    if (surchargeConfig) {
      const surcharge = toDecimal(bill.amount * (surchargeConfig.rate / 100), 2)
      if (surcharge) {
        surchargeInfo.surcharge = toDecimal(bill.amount * (surchargeConfig.rate / 100), 2)
        surchargeInfo.paymentSurchargeConfigUuid = surchargeConfig.id
        surchargeInfo.surchargeName = surchargeConfig.name
        surchargeInfo.surchargeRate = surchargeConfig.rate
      }
    }

    return {
      uniqueId: bill.id,
      amount: toDecimal(bill.amount, 2) as any,
      channelType,
      ext,
      surchargeInfo
    }
  }

  const sceneResultUrlMap = {
    'dining': `/result/${orderId}`,
    'giftcard_buy': `/result/${orderId}`,
    'coupons_buy': `/result/${orderId}`,
  }

  const getReturnUrl = () => {
    const url = window.location.href
    let prefix = url.substr(0, url.indexOf('/pay'))
    if (prefix.indexOf('localhost') > -1) {
      prefix = env.WEBSITE
    }
    const returnUrl = prefix + sceneResultUrlMap[scene]
    console.log('pay return url', returnUrl)
    return returnUrl
  }

  const goResult = () => {
    console.debug('going pay result', sceneResultUrlMap[scene])
    if (scene === 'dining') {
      history.goBack()
    } else {
      history.replace(sceneResultUrlMap[scene])
    }
  }

  const pay = async () => {
    try {
      setShowLoading(true)
      const total = toDecimal(payMobx.order.subtotal + payMobx.order.tax + tip, 2) as any
      if (bills.length > 1) {
        const channels: any[] = await Promise.all(bills.map(x => billToChannel(x)))
        let remainTip = tip
        channels.forEach(x => {
          const channelTip = Math.min(x.amount, remainTip)
          x.tip = toDecimal(channelTip, 2) as any
          remainTip -= channelTip
          x = { ...x, ...x.surchargeInfo }
          delete x.surchargeInfo
        })
        await payMobx.batchPay(orderId, channels)
        goResult()
      } else {
        const { channelType, ext, surchargeInfo, onSuccess, onFailed } = await billToChannel(bills[0])
        try {
          const result = await payMobx.pay({
            ordersId: orderId,
            amount: total,
            tip,
            channel: channelType,
            channelExt: ext,
            surchargeInfo
          })
          handleSinglePayResult(channelType, result)
          if (onSuccess) {
            onSuccess()
          }
        } catch (e) {
          if (e.code === -232) {
            goResult()
          } else {
            if (onFailed) {
              onFailed()
            }
            throw e
          }
        }
      }
    } catch (e) {
      if (e.message !== 'CANCEL') {
        setErrorMessage(e.message)
      }
    } finally {
      setShowLoading(false)
    }
  }

  const handleSinglePayResult = (channel: string, result: any) => {
    if (channel === 'CitconAlipayWeb') {
      const { url } = result
      window.location.href = url
    } else if (channel === 'CitconWechatPayWeb') {
      const { url } = result
      window.location.href = url
    } else if (['WechatPayWeb', 'ShengPayWechatWeb', 'ShengPayWechatWebV2'].includes(channel)) {
      const { wapPayRequest, ordersId } = result
      const { isWeixinMiniProgram, isWeixinBrower } = getPlatform()
      if (['ShengPayWechatWeb', 'ShengPayWechatWebV2'].includes(channel)) {
        wapPayRequest.package = wapPayRequest.packageStr || wapPayRequest.package
      }
      if (isWeixinMiniProgram) {
        miniAppRouteTo({
          url: `/pages/pay/index?p=${encodeURIComponent(JSON.stringify(wapPayRequest))}&o=${ordersId}&scene=${scene}`
        })
      } else if (isWeixinBrower) {
        window.WeixinJSBridge.invoke('getBrandWCPayRequest', wapPayRequest, function (res) {
          if (res.err_msg !== 'get_brand_wcpay_request:ok') {
            setErrorMessage('用户取消')
          } else {
            goResult()
          }
        })
      } else {
        throw new Error('Not in weixin mini program or browser.')
      }
    } else if (channel === 'AlipayWeb') {
      const { url } = result
      window.location.href = url
    } else if (['AlipayApp', 'ShengPayAlipayWeb', 'ShengPayAlipayWebV2'].includes(channel)) {
      const { wapPayRequest } = result
      let tradeNo = wapPayRequest.tradeNo || wapPayRequest.tradeNO
      // if (['ShengPayAlipayWeb', 'ShengPayAlipayWebV2'].includes(channel)) {
      //   tradeNo = wapPayRequest.tradeNO
      // }
      window.AlipayJSBridge.call('tradePay', { tradeNO: tradeNo }, function (result) {
        if (result.resultCode === '9000') {
          goResult()
        } else {
          setErrorMessage('用户取消')
        }
      })
    } else if (channel === 'PayPalWeb') {
      if (result?.token) {
        const { env, envBo } = ENV
        const url = `https://www.${!(env === 'pro' && envBo === 'us') ? 'sandbox.' : ''}paypal.com/checkoutnow?token=${result.token}`
        window.location.href = url
      }
    } else {
      goResult()
    }
  }

  const renderBill = (bill: IBill) => {
    console.log(bill, 'bill``')
    return (
      <Bill
        key={bill.id}
        method={bill.method}
        card={bill.card}
        amount={bill.amount}
        total={payMobx.order ? (payMobx.order.subtotal + payMobx.order.tax + tip) : 0}
        message={bill.message}
        onSelect={(method, card) => onBillMethodAndCardChange(bill, method, card)}
        onDeleteCard={(method, card) => onDeleteCard(method, card)}
        onAmountChange={(amount) => onBillAmountChange(bill, amount)}
      />
    )
  }

  let canPay = true
  bills.forEach(x => {
    if (!x.method) {
      canPay = false
    } else {
      if (x.method === 'giftCard' && x.card) {
        if (!x.card.isPayTip && tip > 0) {
          canPay = false
        }
      }
    }
  })

  return (
    <IonPage className='pay'>
      <Navigator backToPage={() => {
        mktController.goBack(history)
      }}
      />
      <IonLoading isOpen={showLoading} />
      <IonToast
        position='top'
        color='danger'
        isOpen={!!errorMessage}
        onDidDismiss={() => setErrorMessage('')}
        message={errorMessage}
        duration={2000}
      />
      <IonContent ref={contentRef} className={`container ${bo}`}>
        {scene === 'dining' && (
          <div className='section summary'>
            <div className='title'>
              <span>{i18n.t('pay.total')}</span>
              {payMobx.order && <span>{money(payMobx.order.subtotal + payMobx.order.tax + tip)}</span>}
            </div>
            <OrderSummary
              tipSelected={tipSelected}
              tip={tip}
              onTipChange={(tip) => onTipChange(tip)}
            />
          </div>
        )}
        <div className='section method'>
          <div className='title'>
            <span>{i18n.t('pay.paymentMethod')}</span>
            {scene !== 'dining' && payMobx.order && (
              <span>{i18n.t('pay.totalWithColon')}{money(payMobx.order.subtotal + payMobx.order.tax + tip)}</span>
            )}
          </div>
          {bills.map(x => renderBill(x))}
        </div>
      </IonContent>
      <IonFooter className='submit'>
        <button disabled={!canPay} className='pay-button' onClick={pay}>{i18n.t('pay.pay')}</button>
        {payMobx.policy && (
          <div className='agreement'>
            {i18n.t('pay.agreement')}
            <a onClick={() => setShowPolicy(true)}>{i18n.t('pay.policy')}</a>
          </div>
        )}
        <div className='copyright'>
          <i className='iconfont icon-PowerbyeShine2x' />
        </div>
      </IonFooter>
      <IonModal isOpen={showPolicy} cssClass='pay-policy-modal'>
        <IonHeader>{i18n.t('pay.policy')}</IonHeader>
        <IonContent>
          <div className='mobile-policy-content' dangerouslySetInnerHTML={{ __html: payMobx.policy }} />
        </IonContent>
        <IonFooter className='submit'>
          <button className='pay-button' onClick={() => setShowPolicy(false)}>{i18n.t('common.ok')}</button>
        </IonFooter>
      </IonModal>
      <IonModal isOpen={showTokenizer} cssClass='pay-tokenizer-modal' onDidDismiss={onBankCardCancel}>
        <div className='close-modal-btn' onClick={() => setShowTokenizer(false)}>
          <i className='iconfont icon-chevron-left' />
        </div>
        {payMobx.methodChannelMap.bankCardOnline === 'HeartLandBankCard' && (
          <HeartlandTokenizer onToken={onBankCardToken} />
        )}
      </IonModal>
    </IonPage>
  )
}

export default withRouter(observer(Pay))
